import React, { useEffect, useState } from "react";
import { Flag, Trophy, Medal, Timer, Percent } from "lucide-react";
import api from "@/lib/api";

const fmtLap = (s) => {
  if (s == null) return "—";
  const m = Math.floor(s / 60); const r = (s % 60).toFixed(1);
  return m > 0 ? `${m}:${r < 10 ? "0" : ""}${r}` : `${r}s`;
};

const Stat = ({ icon: Icon, label, value, color }) => (
  <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--background))]/40 p-3 text-center">
    <Icon className="w-4 h-4 mx-auto mb-1" style={{ color }} />
    <div className="font-display text-2xl font-extrabold tabular-nums">{value}</div>
    <div className="text-[11px] uppercase tracking-wide text-[hsl(var(--muted-foreground))]">{label}</div>
  </div>
);

export default function RacingCareerCard() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/racing/career").then((r) => setC(r.data)).catch(() => setC(null)); }, []);
  if (!c) return null;
  if (!c.races && (!c.best_laps || c.best_laps.length === 0)) return null;

  return (
    <div className="rounded-2xl border border-[hsl(var(--border))] bg-gradient-to-br from-[#3b9eff]/10 to-transparent p-5 mb-6" data-testid="racing-career-card">
      <div className="font-display font-bold mb-3 flex items-center gap-2"><Flag className="w-5 h-5 text-[hsl(var(--primary))]" /> Racing Career</div>
      <div className="grid grid-cols-4 gap-2.5 mb-4">
        <Stat icon={Flag} label="Races" value={c.races} color="#3b9eff" />
        <Stat icon={Trophy} label="Wins" value={c.wins} color="#fbbf24" />
        <Stat icon={Medal} label="Podiums" value={c.podiums} color="#f97316" />
        <Stat icon={Percent} label="Win rate" value={`${c.win_rate}%`} color="#10b981" />
      </div>
      {c.best_laps && c.best_laps.length > 0 && (
        <div>
          <div className="text-xs font-semibold text-[hsl(var(--muted-foreground))] mb-2 flex items-center gap-1.5"><Timer className="w-3.5 h-3.5" /> Best laps by track</div>
          <div className="space-y-1.5" data-testid="career-best-laps">
            {c.best_laps.map((b, i) => (
              <div key={b.game_id} className="flex items-center justify-between text-sm" data-testid={`career-lap-${i}`}>
                <span className="flex items-center gap-2 truncate"><span>{b.game_cover}</span><span className="truncate">{b.game_title}</span></span>
                <span className="font-mono font-bold text-[hsl(var(--primary))] tabular-nums">{fmtLap(b.best_lap)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
